@if (!showCopyQuantitiesMessage) {
<span data-e2e="title">{{ title }} </span>
} @else {
<span
  data-e2e="make-quantities-default-title"
  i18n="
    ConfigStrip|Config strip make default
    message@@configStripMakeDefaultQuantities"
  class="text-primary font-weight-bold"
  (click)="onCopyQuantities()"
>
  Make these quantities default
</span>
}
